export default __webpack_public_path__ + "static/media/hamburger.62a465bd.svg";